import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { NAV_LINKS, CONTACT } from "../../data/tilio";
import { useLenis, scrollToId } from "../../context";

export default function Footer() {
    const lenis = useLenis();
    return (
        <footer data-testid="site-footer" className="border-t border-ivory/10 bg-pine text-ivory">
            <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-3 lg:px-10 lg:py-20">
                <div>
                    <div className="flex items-center gap-2.5" data-testid="footer-logo">
                        <span
                            aria-hidden="true"
                            className="block shrink-0"
                            style={{
                                width: "33px",
                                height: "36px",
                                backgroundColor: "currentColor",
                                WebkitMaskImage: "url(/images/tilio-domki-na-wynajem-mazowsze.png)",
                                maskImage: "url(/images/tilio-domki-na-wynajem-mazowsze.png)",
                                WebkitMaskRepeat: "no-repeat",
                                maskRepeat: "no-repeat",
                                WebkitMaskSize: "contain",
                                maskSize: "contain",
                                WebkitMaskPosition: "center",
                                maskPosition: "center",
                            }}
                        />
                        <p className="font-serif text-4xl tracking-tight">Tilio</p>
                    </div>
                    <p className="mt-4 max-w-xs text-[17px] leading-[1.6] text-ivory/60">
                        Trzy domki nad rzeką Liwiec. Godzina od Warszawy, cały rok.
                    </p>
                    <div className="mt-6 flex gap-3">
                        <a
                            data-testid="footer-instagram"
                            href="https://www.instagram.com/tiliodomkinadliwcem/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            className="flex h-10 w-10 items-center justify-center border border-ivory/20 transition-[background-color,border-color] duration-300 hover:border-ivory/60 hover:bg-ivory/10"
                        >
                            <Instagram className="h-4 w-4" strokeWidth={1.25} />
                        </a>
                        <a
                            data-testid="footer-facebook"
                            href="https://www.facebook.com/profile.php?id=61550992990056"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                            className="flex h-10 w-10 items-center justify-center border border-ivory/20 transition-[background-color,border-color] duration-300 hover:border-ivory/60 hover:bg-ivory/10"
                        >
                            <Facebook className="h-4 w-4" strokeWidth={1.25} />
                        </a>
                    </div>
                </div>
                <div>
                    <p className="text-[13px] uppercase tracking-[0.35em] text-ivory/50">Nawigacja</p>
                    <ul className="mt-5 space-y-3">
                        {NAV_LINKS.map((l) => (
                            <li key={l.href}>
                                <button
                                    data-testid={`footer-link-${l.href.slice(1)}`}
                                    onClick={() => scrollToId(lenis, l.href)}
                                    className="link-underline text-base text-ivory/75 transition-colors duration-300 hover:text-ivory"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="text-[13px] uppercase tracking-[0.35em] text-ivory/50">Kontakt</p>
                    <ul className="mt-5 space-y-4 text-[17px] text-ivory/75">
                        <li>
                            <a data-testid="footer-phone" href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 transition-colors duration-300 hover:text-ivory">
                                <Phone className="h-4 w-4 shrink-0" strokeWidth={1.25} /> {CONTACT.phone}
                            </a>
                        </li>
                        <li>
                            <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 transition-colors duration-300 hover:text-ivory">
                                <Mail className="h-4 w-4 shrink-0" strokeWidth={1.25} /> {CONTACT.email}
                            </a>
                        </li>
                        <li className="flex items-start gap-3">
                            <MapPin className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={1.25} />
                            <span data-testid="footer-address">{CONTACT.address}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-ivory/10">
                <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-6 py-6 text-sm text-ivory/45 sm:flex-row lg:px-10">
                    <p>© {new Date().getFullYear()} Tilio — domki nad rzeką Liwiec</p>
                    <div className="flex gap-6">
                        <Link to="/regulamin" data-testid="footer-regulamin" className="transition-colors duration-300 hover:text-ivory/80">Regulamin rezerwacji i pobytu</Link>
                        <Link to="/polityka-prywatnosci" data-testid="footer-polityka" className="transition-colors duration-300 hover:text-ivory/80">Polityka prywatności</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
